import React, { Component } from 'react';
import Column1 from './Column1'
import Column2 from './Column2'
import FooterMobile from './FooterMobile'
import { drawCanvas } from './utilities/utilities.js';

class App extends Component {
  constructor(props) {
    super(props)    
    this.onResize = this.onResize.bind(this)    
  }  

  onResize() {
    drawCanvas();
  }

  modalToggled(on) {
    this.setState({ modalOn: on });
  }

  componentDidMount() {
    if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
      window.location.href = `https://${window.location.hostname}${window.location.pathname}`;
    }
    drawCanvas()
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('onscroll', this.onScroll)
  }

  render() {
    return (
      <div>
        <canvas id="canvas"></canvas>
        <div className="wrapper-all">
          <Column1 />
          <Column2 />
          <FooterMobile />
        </div>
      </div>
    )
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js